type Domain = 'admin' | 'user' | undefined;

export const DOMAIN: Domain = (() => {
  switch (process.env.REACT_APP_DOMAIN) {
    case 'admin':
      return 'admin';
    case 'user':
      return 'user';
    default:
      return undefined;
  }
})();

export const SCREEN_WIDTH = {
  TABLET: 992,
  MOBILE: 576
};

export const enum CryptographyType {
  DECRYPTIONS = 'decryptions',
  ENCRYPTIONS = 'encryptions'
}

export const enum ZIndexType {
  Z_INDEX_DEFAULT = '1055',
  Z_INDEX_BLUR = '4'
}

export enum AccountStatusType {
  Pending = 5
}

export const enum UsageAccessTypes {
  COUNT_AMOUNT = 'countAmount',
  COUNT_DATE = 'countDate',
  AUTHORIZED_USER_COUNT = 'authorizedUserCount',
  LOCATION_ACCESS = 'geofencingSetCount',
  PREVENT_COPY_COUNT = 'preventCopyCount',
  PREVENT_FORWARD_COUNT = 'preventForwardCount',
  PREVENT_PRINT_COUNT = 'preventPrintCount',
  PREVENT_SAVE_COUNT = 'preventSaveCount',
  REVOKE_COUNT = 'revokeCount',
  SHRED_COUNT = 'shredCount',
  ACCESS_TIME = 'timelineSetCount',
  TOTAL_ITEMS = 'totalItems'
}

export const enum ReportTypes {
  ACTIVE_USER_REPORT = 'activeUserReport',
  ENCRYPT_DECRYPT_REPORT = 'encryptDecryptReport',
  INSTALLATION_REPORT = 'installationReport',
  NEW_ACCOUNT_REPORT = 'newAccountReport',
  USAGE_ACCESS_REPORT = 'usageAccessReport'
}

export const usageAccessChartColors: Record<string, string> = {
  countAmount: '#4C4ACF',
  authorizedUserCount: '#7977DB',
  preventCopyCount: '#39F',
  preventPrintCount: '#9CF',
  preventSaveCount: '#46D9A4',
  preventForwardCount: '#90E8C8',
  timelineSetCount: '#F4E241',
  geofencingSetCount: '#F07439',
  revokeCount: '#F79CAC',
  shredCount: '#F0395A'
};

export const chartColors: { [key: string]: string } = {
  //platforms
  android: '#4C4ACF',
  ios: '#39F',
  macos: '#46D9A4',
  web: '#F4E241',
  windows: '#F07439',
  agentless: '#F0395A',
  //encripts
  encrypts: '#4C4ACF',
  decrypts: '#F07439',
  //licenses
  free: '#4C4ACF',
  professional: '#F07439'
};

export const enum DateType {
  START_DATE = 'startDate',
  END_DATE = 'endDate'
}

export const enum VaultStatus {
  ACTIVE = 'ACTIVE',
  REVOKE = 'REVOKE',
  SHRED = 'SHRED'
}

export const DECRYPTIONS_COLORS: { [key: string]: string } = {
  Failure: '#F0395A',
  Success: '#46D9A4'
};

// The timeout value in milliseconds.
export const MOUSE_ACTIVITY_DETECTION = {
  INACTIVITY: 480000,
  WARING_TIME: 120000,
  URGENT_TIME: 60000,
  LOGOUT_TIME: 0
};

export const formatFileSize = (size: string) => {
  const sizeConvert = parseFloat(size) / (1024 * 1024);
  const totalSizeRounded = Math.floor(sizeConvert * 100) / 100;
  return totalSizeRounded;
};

export const DATE_FORMAT = {
  MM_DD_YYYY: 'MM/DD/YYYY',
  MMMM_DD_YYYY: 'MMMM DD, YYYY',
  DD_MM_YYYY: 'DD/MM/YYYY'
};
